export default __webpack_public_path__ + "assets/gh-video-placeholder.5c70fbb5.jpg";